"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseLockedTableIdFromReceipts = parseLockedTableIdFromReceipts;
function parseLockedTableIdFromReceipts(receiptsContents) {
    const ownertableIdPairs = [];
    receiptsContents.map((receipt) => {
        const ownertableIdPair = {
            owner: receipt.owner,
            tableId: receipt.locked_balance.id,
        };
        ownertableIdPairs.push(ownertableIdPair);
    });
    return ownertableIdPairs;
}
//# sourceMappingURL=parseLockedTableId.js.map